import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { getPurchaseDetails } from './data/DetailPurchase';
import { getDetailsTransaction } from './data/DetailsFailedTransactions';
import { getDistributorDetails } from './data/DetailsHistoryPrepaid';
import { getPaymentDetails } from './data/DetailsNetPay';
import { getPaymentStatusDetails } from './data/DetailsOpenPay';
import { getPurchasePaymentInformationAiralo } from './data/DetailsPurchaseAiralo';
import { getAddressPurchaseOrdersDetails } from './data/DetailsPurchaseOrdersIpb';
import { getAddressDetails } from './data/DetailsSimIpb';
import { getPaymentDetailsSTP } from './data/DetailsSTP';
import { getPaymentDetailsToku } from './data/DetailsToku';
import { getVinculationInformation } from './data/DetailsVinculationOrders';

const titleStyle = { color: '#7A3C92' };
const spanStyle = { fontSize: 15, wordWrap: 'break-word' };
const valueStyle = {
  textAlign: 'right',
  marginTop: '8px',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const PaymentInfo = ({ orderDetails, title, type }) => {
  let fields = [];

  if (type === 'detailsSTP') {
    fields = getPaymentDetailsSTP(orderDetails);
  } else if (type === 'detailsToku') {
    fields = getPaymentDetailsToku(orderDetails);
  } else if (type === 'detailsNetPay') {
    fields = getPaymentDetails(orderDetails);
  } else if (type === 'detailsHistoryPrepaid') {
    fields = getDistributorDetails(orderDetails);
  } else if (type === 'detailsSimIpb') {
    fields = getAddressDetails(orderDetails);
  } else if (type === 'detailPurchase') {
    fields = getPurchaseDetails(orderDetails);
  } else if (type === 'detailsOpenPay') {
    fields = getPaymentStatusDetails(orderDetails);
  } else if (type === 'DetailsPurchaseOrdersIpb') {
    fields = getAddressPurchaseOrdersDetails(orderDetails);
  } else if (type === 'DetailsVinculationOrders') {
    fields = getVinculationInformation(orderDetails);
  } else if (type === 'DetailsFailedTransactions') {
    fields = getDetailsTransaction(orderDetails);
  } else if (type === 'AiraloDetails') {
    fields = getPurchasePaymentInformationAiralo(orderDetails);
  }

  return (
    <Grid container className='device-info' direction={'column'}>
      <Grid item size={{ xs: 12 }}>
        <span style={titleStyle}>{title}</span>
      </Grid>
      {fields.map((field, index) => (
        <Grid container key={index}>
          <Grid item size={{ xs: 6 }}>
            <span style={spanStyle}>{field.label}:</span>
          </Grid>
          <Grid item size={{ xs: 6 }} style={valueStyle}>
            <Typography variant='body1'>
              {field.value !== undefined && field.value !== null ? field.value : 'N/A'}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default PaymentInfo;
